export default "__VITE_ASSET__BnLE92Qq__"